import { EllipsisHorizontalIcon, TrashIcon } from "@heroicons/react/24/outline";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@mindstonehq/ui";
import Markdown from "marked-react";
import React from "react";
import { extractMentionDataFromStr } from "../comments/utils";
import { Trans } from "@lingui/react/macro";
import { formatDate } from "~/utils";
import { displayNameOf, initialsOf } from "~/utils/display-name";

export default function CommentRow({
  comment,
  handleDelete,
}: {
  comment: {
    id: string;
    canEdit: boolean;
    createdAt: string;
    profile: {
      displayName: string;
      username: string;
      profilePictureURL: string;
    };
    content: string;
  };
  handleDelete: (id: string) => void;
}) {
  let date = new Date(comment.createdAt);

  return (
    <div key={comment.id} className="flex flex-col space-y-2 pb-2">
      <div className="flex min-w-0 items-center space-x-1 justify-between">
        <div className="flex min-w-0 items-center space-x-1">
          <Avatar className="h-8 w-8">
            <AvatarImage src={comment.profile.profilePictureURL} />
            <AvatarFallback>{initialsOf(comment.profile)}</AvatarFallback>
          </Avatar>
          <div className="flex min-w-0 flex-col">
            <div className="text-sm line-clamp-1 [overflow-wrap:anywhere]">
              {displayNameOf(comment.profile)}
            </div>
            <div className="text-xs text-placeholder-foreground">
              {formatDate(date)} {date.toLocaleTimeString()}
            </div>
          </div>
        </div>
        {comment.canEdit && (
          <DropdownMenu>
            <DropdownMenuTrigger>
              <Button variant="ghost" className="px-2">
                <EllipsisHorizontalIcon className="h-6 w-6" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuItem onSelect={(e) => handleDelete(comment.id)}>
                <TrashIcon className="h-4 w-4 mr-2" />
                <Trans>Delete</Trans>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        )}
      </div>
      <div className="prose dark:prose-invert pt-2">
        <Markdown>
          {extractMentionDataFromStr(comment.content).plainTextValue}
        </Markdown>
      </div>
    </div>
  );
}
